export default "__VITE_ASSET__BAI45RQA__"